import {Injectable} from '@angular/core';
import * as UIModels from '@shared-models/index';
import {UserProfileService} from './user-profile.service';
import {UserRoleEnum} from '@shared-models/common.enums';

@Injectable({
    providedIn: 'root'
})

export class UserRoleService {

    constructor(
        private userProfileService: UserProfileService,
    ) {
    }


    get isCSBA(): boolean {
        const user = this.userProfileService.user;
        const csbaRoles = [UIModels.CE.UserRoleEnum.CsbaUS, UIModels.CE.UserRoleEnum.CsbaUSI, UIModels.CE.UserRoleEnum.Csba];
        return user && (user.userRoleIds?.length ? user.userRoleIds.some(id => csbaRoles.includes(id)) : csbaRoles.includes(user.userRoleId));
    }

    get isEmployee(): boolean {
        const user = this.userProfileService.user;
        return user && (user.userRoleIds?.length ? user.userRoleIds.some(id => id === UIModels.CE.UserRoleEnum.Employee) : user.userRoleId === UIModels.CE.UserRoleEnum.Employee);
    }

    get isFrontDesk(): boolean {
        const user = this.userProfileService.user;
        return user && (user.userRoleIds?.length ? user.userRoleIds.some(id => id === UIModels.CE.UserRoleEnum.FrontDesk) : user.userRoleId === UIModels.CE.UserRoleEnum.FrontDesk);
    }

    get isSecurityAdmin(): boolean {
        const user = this.userProfileService.user;
        const securityRoles = [UserRoleEnum.Security, UserRoleEnum.SecurityUS, UserRoleEnum.SecurityUSI];
        return user && (user.userRoleIds?.length ? user.userRoleIds.some(id => securityRoles.includes(id)) : securityRoles.includes(user.userRoleId));
    }

    getRole(): UIModels.CE.UserRoleEnum {
        return this.userProfileService.user.userRoleId;
    }
}
